<template>
    <!-- 被保人填寫資料重複區域 -->
    <div id="insureDetail">
        <div class="popupBg" v-show="oftenListPop">
            <div class="container">
                <div class="top">
                    <h3>匯入常用名單</h3>
                    <img src="../../assets/close.svg" alt="" srcset="" class="close">
                </div>
                <div ref="oftenListArea" v-show="oftenListPop">
                    <oftenList @traveler="getTraveler"/>
                </div>
            </div>
        </div>
        <div class="insure" @change="saveInsureData">
            <div class="topCheck">
                <label class="checkbox clarity-unmask" v-if="insureType <= 2">
                    <input type="checkbox" v-model="insureData.sameCheck" @change="sameWithApplicant" />
                    <div class="checkStyle"></div>
                    同要保人資料
                </label>
                <label class="checkbox" v-if="policyTypeSwitch === 'A'">
                    <input type="checkbox" v-model="insureData.isAddTraveler" />
                    <div class="checkStyle"></div>
                    加入常用名單
                </label>
                <div ref="oftenListBtn" id="insertData" class="right" @click="openOftenList" v-show="!insureData.sameCheck" v-if="policyTypeSwitch === 'A'">
                    <img src="../../assets/insert.svg" alt=""> 匯入常用名單
                </div>
            </div>
            <div class="oneline">
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check1 }">{{ user }}姓名</div>
                    <input type="text" class="inputStyle tlf_r_f1 clarity-mask" :id="'insuredName_Detail'+user_id" v-model="insureData.insureName" :class="{ 'alert': check1 }">
                </div>
            </div>
            <div class="inline" v-if="applicantData.needEnglishPolicy">
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check2 }">英文姓名</div>
                    <input type="text" class="inputStyle tlf_r_f1" :id="'insuredEnglishName_Detail'+user_id" v-model="insureData.insuredEngName" :class="{ 'alert': check2 }">
                </div>
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check13 }">護照號碼</div>
                    <input type="text" class="inputStyle tlf_n_all" :id="'insuredPassPortNo_Detail'+user_id" v-model="insureData.passportNo" :class="{ 'alert': check13 }" maxlength="10">
                </div>
            </div>
            <div class="inline">
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check3 }">身分證 / 居留證</div>
                    <input type="text" class="inputStyle tlf_n_l5 clarity-mask" :id="'insuredIdNo_Detail'+user_id" v-model="insureData.insureIdNo" v-on:blur="checkIdType"
                        :class="{ 'alert': check3 }" @keyup="upper">
                </div>
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check4 }">國籍</div>
                    <model-select :options="nationOptions"
                                  class="inputStyle arrow selectSearch clarity-mask"
                                  :class="{ 'alert': check4 }"
                                  v-model="insureDataRiskCountry"
                                  placeholder="請選擇國籍"
                    >
                    </model-select>
                </div>
            </div>
            <div class="inline" v-if="!idType">
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check10 }">居留證核發日期</div>
                    <date-picker
                        v-model:value="insureData.residentIssueDate"
                        class="inputStyle calendar"
                        :class="{ 'alert': check10 }"
                        :lang="lang"
                        :editable="false"
                        @change="saveInsureData"
                        :valueType="'format'"
                    ></date-picker>
                    <p class="alertStr"></p>
                </div>
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check11 }">居留證期限/有效日期
                        <label class="checkbox right">
                            <input type="checkbox" v-model="insureData.isPermanentResident" @change="checkPermanentResident"/>
                            <div class="checkStyle"></div>
                            我是永久居留者
                        </label>
                    </div>
                    <date-picker
                        v-model:value="insureData.residentPeriodDate"
                        class="inputStyle calendar"
                        :class="{ 'alert': check11 }"
                        :lang="lang"
                        :editable="false"
                        :disabled="insureData.isPermanentResident"
                        @change="saveInsureData"
                        :valueType="'format'"
                    ></date-picker>
                    <p class="alertStr"></p>
                </div>
            </div>
            <div class="oneline" v-if="!idType">
                <div class="inputTitle" :class="{ 'pinkText': check12 }">居留證背面序號</div>
                <input type="text" class="inputStyle" v-model="insureData.residentBackSn" :class="{ 'alert': check12 }">
                <p class="alertStr"></p>
            </div>
            <BirthdayChange :dateTimeProps="insureData.insureBirthday" @getDateTime="getInsureBirthday"
                        :key="reloadYearChangeKey" :nickName="'insure' + user_id" ref="yearRef"/>
            <div class="oneline">
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check5 }">職/行業別</div>
                    <select name="" id="" class="inputStyle arrow clarity-mask" v-model="insureData.insureJob"
                        :class="{ 'alert': check5 }">
                        <option v-for="(job, index) in riskJobList" :value="job.jobCode" :key="index">{{ job.jobName }}</option>
                    </select>
                </div>
            </div>
            <div class="oneline addressTitle">
                <div class="inputTitle" :class="{ 'pinkText': check6 && check7 && check8 }">居住地址</div>
                <div class="inputTitle formBtn right" @click="sameAddress" v-if="!insureData.sameCheck">同要保人地址</div>
            </div>
            <div class="inline">
                <div class="inputControl">
                    <select name="" id="" class="inputStyle arrow clarity-mask" v-model="insureData.insureAddrCity"
                        @change="getAddrZipList(null)" :class="{ 'alert': check6 }" >
                        <option value="" selected disabled>縣市</option>
                        <option v-for="(city, index) in cityList" :value="city.id" :key="index">{{ city.cityName }}</option>
                    </select>
                </div>
                <div class="inputControl">
                    <select class="inputStyle arrow clarity-mask" v-model="insureData.insureAddrZip" :class="{ 'alert': check7 }">
                        <option value="" selected disabled>區域</option>
                        <option v-for="(zip, index) in zipList" :value="zip.id" :key="index">{{ zip.zipName }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="oneline">
                <div class="inputControl">
                    <input type="text" name="" class="inputStyle tlf_r_f6 clarity-mask" :id="'insuredAddress_Detail'+user_id" v-model="insureData.insureAddrs"
                        :class="{ 'alert': check8 }">
                </div>
            </div>
            <div class="oneline">
                <div class="inputControl">
                    <div class="inputTitle" :class="{ 'pinkText': check9 }">被保險人是要保人的誰(關係)：<span class="clarity-unmask">{{showInsureRelation()}}</span></div>
                    <select name="" id="" class="inputStyle arrow clarity-unmask" v-model="insureData.insureRelation"
                        :class="{ 'alert': check9 }">
                        <option value="" selected disabled>請選擇關係</option>
                        <option value="SELF" v-if="!(policyType === 'INSURE' && insureType === 4)">本人</option>
                        <option value="SPOUSE" v-if="!insureData.sameCheck && !(policyType === 'INSURE' && insureType === 4)&& policyTypeSwitch === 'A'">配偶</option>
                        <option value="CHILD" v-if="!insureData.sameCheck && policyTypeSwitch === 'A'">子女</option>
                        <option value="PARENT" v-if="!insureData.sameCheck && !(policyType === 'INSURE' && insureType === 4)&& policyTypeSwitch === 'A'">父母</option>
                        <option value="SIBLING" v-if="!insureData.sameCheck && !(policyType === 'INSURE' && insureType === 4)&& policyTypeSwitch === 'A'">兄弟姊妹</option>
                        <option value="GRANDCHILD" v-if="!insureData.sameCheck && !(policyType === 'INSURE' && insureType === 4)&& policyTypeSwitch === 'A'">祖孫</option>
                        <option value="OTHER" v-if="!insureData.sameCheck && !(policyType === 'INSURE' && insureType === 4)&& policyTypeSwitch === 'A'">其他</option>
                    </select>
                </div>
            </div>
            <div class="inline clarity-unmask">
                <div class="inputTitle radioLine">身故受益人</div>
                <div class="radioLine">
                    <input type="radio" :name="'beneficiaryType' + user_id" :id="'beneficiaryType' + user_id + '1'"
                        value="1" v-model="insureData.beneficiaryType" checked="checked"
                        @change="beneficiaryChange($event)">
                    <label :for="'beneficiaryType' + user_id + '1'">
                        <span></span>
                        法定繼承人
                    </label>
                    <input type="radio" :name="'beneficiaryType' + user_id" :id="'beneficiaryType' + user_id + '2'"
                        value="2" v-model="insureData.beneficiaryType" @change="beneficiaryChange($event)">
                    <label :for="'beneficiaryType' + user_id + '2'">
                        <span></span>
                        指定受益人
                    </label>
                </div>
            </div>
        </div>
        <div class="beneficiaryShare" v-if="insureData.beneficiaryType === '2'" @change="saveInsureData">
            <div class="shareWayArea clarity-unmask">
                <div class="inputTitle radioLine">受益人分配方式</div>
                <div class="radioLine" @change="saveInsureData">
                    <input type="radio" :name="'beneficiaryShare' + user_id" :id="'beneficiaryShare' + user_id + '1'"
                        value="2" v-model="insureData.beneficiaryShareType">
                    <label :for="'beneficiaryShare' + user_id + '1'">
                        <span></span>
                        均分
                    </label>
                    <input type="radio" :name="'beneficiaryShare' + user_id" :id="'beneficiaryShare' + user_id + '2'"
                        value="1" v-model="insureData.beneficiaryShareType">
                    <label :for="'beneficiaryShare' + user_id + '2'">
                        <span></span>
                        順位
                    </label>
                </div>
            </div>
            <div class="beneficFrame" v-for="(beneficiary, index) in insureData.beneficiaryArray" :key="index">
                <img src="../../assets/close.svg" v-if="insureData.beneficiaryArray.length !== 1"
                    @click="deleteBeneficiary(index)" class="delete" alt="close">
                <BeneficiaryCell
                    :user_id="user_id"
                    :beneficiary_id="index + 1"
                    :key="index + reloadBeneficiaryKey"
                    :beneficiaryCheck="insureCheck"
                    :insureType="insureType"
                    :applicantData="applicantData"
                    ref="beneficiaryRef"
                />
                <div class="greenLine" v-if="index < 2"></div>
            </div>
            <div class="btnArea" v-if="insureData.beneficiaryArray.length < 3">
                <div id="addBeneficiary" class="addBeneficiary btn" @click="addBeneficiary()">
                    新增受益人<img src="../../assets/addBeneficiary.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
        import BirthdayChange from "@/components/birthdayChange.vue";
        import BeneficiaryCell from "@/components/detail/BeneficiaryCell.vue";
        import LoadData from "@/utils/loadData";
        import CheckData from "@/utils/checkData";
        import oftenList from "@/components/detail/oftenList.vue";
        import { postApi } from "@/utils/callApi";
        import _ from "lodash";
        import {ModelSelect}  from 'vue-search-select';
        import moment from "moment";
        import {onMounted, onUnmounted, ref, watch} from "vue";
        import DatePicker from 'vue-datepicker-next';
        import 'vue-datepicker-next/index.css';
        import apiConfig from "@/utils/apiConfig";
        import Swal from "sweetalert2";

        const props = defineProps({
            mainSameCheck:Number,
            user: String,
            user_id: Number,
            applicantData: Object,
            insureCheck:Boolean,
            insureType: Number,
        })
        const emits = defineEmits(["globalSameCheck"]);
        let riskCountryList = {};//國籍清單
        let pageStorage = {};
        let jwtInfo = {};

        const nationOptions = ref([]);//顯示國籍清單
        const riskJobList = ref([]);//職業清單
        const cityList = ref([]);//城市清單
        const zipList = ref([])//區域清單
        const idType = ref(true);//true:台灣人,false:外國人
        const insureData = ref({
            sameCheck: false,
            isAddTraveler: false,
            insureIdNo: '',
            insureRiskCountry: '',
            insureName: '',
            insuredEngName: '',
            insureBirthday: {},
            insureJob: '000',
            insureAddrCity: '',
            insureAddrZip: '',
            insureAddrs: '',
            insureRelation: '',
            residentBackSn: '',//背後序號
            passportNo:'',//護照號碼
            residentIssueDate: '',//核發日期
            residentPeriodDate: '',//居留期限
            isPermanentResident : false,//永久居留
            beneficiaryType: '1', //身故受益人 1:法定 2:指定
            beneficiaryShareType: '1',//分配方式 1:順位 2:均分
            beneficiaryArray: [],
        });
        const insureDataRiskCountry = ref("");
        const policyType = ref("");
        const policyTypeSwitch = ref("");
        const reloadYearChangeKey = ref(0);
        const oftenListPop = ref(false);
        const oftenListBtn = ref(null);
        const oftenListArea = ref(null);
        const lang = ref({
            formatLocale: {
                monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
            },
            monthBeforeYear: false,
        })//設定datepicker介面
        const beneficiaryRef = ref();
        const yearRef = ref();
        const reloadBeneficiaryKey = ref(0);
        const check1 = ref(false);
        const check2 = ref(false);
        const check3 = ref(false);
        const check4 = ref(false);
        const check5 = ref(false);
        const check6 = ref(false);
        const check7 = ref(false);
        const check8 = ref(false);
        const check9 = ref(false);
        const check10 = ref(false);
        const check11 = ref(false);
        const check12 = ref(false);
        const check13 = ref(false);

        //載入國籍清單
        const getRiskCountryList = () => {
            LoadData.getRiskCountryList(function (data) {
                riskCountryList = data;
                if(insureData.value.insureIdNo.length > 0){
                    checkIdType();
                }
            });
        }
        //載入職行業清單
        const getRiskJobList = () => {
            LoadData.getRiskJobList(function (data) {
                riskJobList.value = data;
            });
        }
        //載入縣市清單
        const getAddrCityList = () => {
            LoadData.getAddrCityList(function (data) {
                cityList.value = data;
            });
        }
        //載入區域清單
        const getAddrZipList = (setZip) => {
            if(insureData.value.insureAddrCity){
               const cityObject = cityList.value.find(city => city.id === insureData.value.insureAddrCity)
                LoadData.getAddrZipList(cityObject.cityCode, function (data) {
                    zipList.value = data;
                    insureData.value.insureAddrZip = setZip || "";
                    saveInsureData();
                });
            }
        }
        //載入pageStorage
        const loadPageStorage = () =>{
            pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));
            policyType.value = pageStorage.policyType;
            policyTypeSwitch.value = pageStorage.getPolicyTypeSwitch;
        }
        //檢查ID類型
        const checkIdType = () => {
            const checkIdType = CheckData.id(insureData.value.insureIdNo);
            if (checkIdType === 'resident') {
                idType.value = false;
                if (insureDataRiskCountry.value === "台灣(Taiwan)") {
                    insureDataRiskCountry.value = "";
                }

                if(nationOptions.value.length !== riskCountryList.length){
                    nationOptions.value = [];
                    riskCountryList.forEach(rc => {
                        nationOptions.value.push({
                            value: rc.riskCountryName,
                            text: rc.riskCountryName
                        });
                    });
                }
            } else {
                nationOptions.value = [];
                nationOptions.value.push({
                    value: "台灣(Taiwan)",
                    text: "台灣(Taiwan)"
                });

                idType.value = true;
                insureDataRiskCountry.value = "台灣(Taiwan)";
                insureData.value.residentBackSn = "";
                insureData.value.residentIssueDate = "";
                insureData.value.residentPeriodDate = "";
            }
            saveInsureData();
        }
        //載入detailStorage
        const loadDetailStorage = ()=>{
            const detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
            if(detailStorage != null){
                if (JSON.stringify(detailStorage.insureData[props.user_id]) !== '{}') {
                    insureData.value = detailStorage.insureData[props.user_id]
                    if (insureData.value.insureIdNo !== '') {
                        checkIdType();
                    }
                    if (insureData.value.insureAddrCity !== '') {
                        getAddrZipList(insureData.value.insureAddrZip);
                    }
                    insureDataRiskCountry.value = insureData.value.insureRiskCountry;

                    reloadYearChangeKey.value += 1;
                }
            }
        }
        //更動資料儲存至 sessionStorage
        const saveInsureData = ()=>{
            const detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));

            if(JSON.stringify(detailStorage.insureData[props.user_id]) !== '{}'){
                if(detailStorage.insureData[props.user_id].beneficiaryArray.length !== 0){
                    insureData.value.beneficiaryArray = detailStorage.insureData[props.user_id].beneficiaryArray;
                }
            }

            detailStorage.insureData[props.user_id] = insureData.value;
            sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));

            if(props.insureCheck === true){
                checkForm();
                //$(".alert").parent().append("<p></p>");
            }
        }

        //OftenList點擊外面收合
        const clickOutSide = (e) => {
            if(policyTypeSwitch.value === 'A') {
                if (!(oftenListBtn.value.contains(e.target) || oftenListArea.value.contains(e.target))) {
                    oftenListPop.value = false;
                }
            }
        }
        //同要保人
        const sameWithApplicant = () =>{
            if (insureData.value.sameCheck) {
                insureData.value.insureIdNo = props.applicantData.applicantIdNo;
                checkIdType(insureData.value.insureIdNo);
                insureData.value.insureRiskCountry = props.applicantData.applicantRiskCountry;
                insureDataRiskCountry.value = props.applicantData.applicantRiskCountry;
                insureData.value.insureName = props.applicantData.applicantName;
                insureData.value.insuredEngName = props.applicantData.applicantEngName;
                insureData.value.insureBirthday = props.applicantData.applicantBirthday;
                insureData.value.insureJob = props.applicantData.applicantJob;
                insureData.value.insureAddrCity = props.applicantData.applicantAddrCity;
                getAddrZipList(props.applicantData.applicantAddrZip);//需要先更新區域清單
                insureData.value.insureAddrs = props.applicantData.applicantAddrs;
                insureData.value.insureRelation = 'SELF'

                reloadYearChangeKey.value += 1;

                saveInsureData();

            } else {
                cleanInsure();
            }

            emits('globalSameCheck', props.user_id);
        }
        //同要保人-被保人檢查
        const insureGlobalSameCheck = ()=>{
            if(insureData.value.sameCheck){
                insureData.value.sameCheck = false;
                cleanInsure();
            }
        }

        const cleanInsure = ()=>{
            insureData.value.insureIdNo = '';
            idType.value = true;
            insureData.value.insureRiskCountry = '台灣(Taiwan)';
            insureDataRiskCountry.value = '台灣(Taiwan)';
            insureData.value.insureName = '';
            insureData.value.insuredEngName = '';
            insureData.value.passportNo = '';
            insureData.value.insureBirthday = {};
            insureData.value.insureJob = '000';
            insureData.value.insureAddrCity = '';
            insureData.value.insureAddrZip = '';
            insureData.value.insureAddrs = '';
            insureData.value.insureRelation = ''

            reloadYearChangeKey.value += 1;

            saveInsureData();
        }
        //同要保人地址
        const sameAddress = () => {
            insureData.value.insureAddrCity = props.applicantData.applicantAddrCity;
            getAddrZipList(props.applicantData.applicantAddrZip);//需要先更新區域清單
            insureData.value.insureAddrs = props.applicantData.applicantAddrs;
        }
        //帶入常用清單
        const getTraveler = (traveler) => {
            insureData.value.insureName = traveler.insureName;
            insureData.value.insureIdNo = traveler.insureIdNo;
            insureData.value.insuredEngName = traveler.insuredEngName;

            insureData.value.insureAddrCity  = traveler.insuredCityCodeId;
            getAddrZipList(traveler.insuredZipCodeId);//需要先更新區域清單
            insureData.value.insureAddrs = traveler.insuredAddress;
            insureData.value.passportNo = traveler.passportNo;
            const birthday = moment(traveler.insureBirthday);
            insureData.value.insureBirthday = {
                year: birthday.year(),
                month: birthday.month() + 1,
                date: birthday.date(),
            }
            reloadYearChangeKey.value += 1;
            checkIdType();//放最後順便更新detailStorage
            oftenListPop.value = false; //關閉常用名單視窗
        }

        //加入常用清單
        const addTraveler = () => {
            if (insureData.value.isAddTraveler) {
                var data = {
                    'insuredIdNo': insureData.value.insureIdNo,
                    'insuredName': insureData.value.insureName,
                    'insuredBirthday': insureData.value.insureBirthday.year
                        + "-" + insureData.value.insureBirthday.month
                        + "-" + insureData.value.insureBirthday.date,
                    'insuredEngName': insureData.value.insuredEngName,
                    'passportNo':insureData.value.passportNo,
                    'insuredCityCodeId':insureData.value.insureAddrCity,
                    'insuredZipCodeId':insureData.value.insureAddrZip,
                    'insuredAddress':insureData.value.insureAddrs
                }
                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                postApi(apiConfig.addTraveler, jwtInfo.token, null, null, data)
                    .then((response) => {
                        var addTravelerRes = response.data;
                        if (addTravelerRes.code === 200) {
                            //Do Nothing
                        } else {
                            //跳出錯誤
                            Swal.fire({
                                title: "新增常用清單錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>'+ addTravelerRes.message + '</p>',
                            });
                        }
                    })
                    .catch(() => {
                        //跳出錯誤
                        Swal.fire({
                            title: "新增常用清單錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>連線錯誤</p>',
                        });
                    })
            }
        }
        //新增受益人
        const addBeneficiary = () => {
            const detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
            if (detailStorage.insureData[props.user_id].beneficiaryArray.length < 3) {
                detailStorage.insureData[props.user_id].beneficiaryArray.push({});
                sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));
                saveInsureData();
            }
        }
        //刪除受益人
        const deleteBeneficiary = (index) => {
            const detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
            if (detailStorage.insureData[props.user_id].beneficiaryArray[index] != null) {
                detailStorage.insureData[props.user_id].beneficiaryArray.splice(index, 1);
                insureData.value.beneficiaryArray = detailStorage.insureData[props.user_id].beneficiaryArray
                sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));
                saveInsureData();

                //觸發受益人重整
                if(beneficiaryRef.value){
                    beneficiaryRef.value.forEach(bfRef => {
                        bfRef?.loadDetailStorage();
                    });
                }
            }
        }
        //選擇身故受益人顯示受益人填寫欄位
        const beneficiaryChange = (event) =>{
            if (event.target.value === '2') {
                if (insureData.value.beneficiaryArray.length === 0) {
                    insureData.value.beneficiaryArray.push({});
                }
            } else {
                insureData.value.beneficiaryArray = [];
            }
        }
        //開啟關閉OftenList
        const openOftenList = () => {
            oftenListPop.value = !oftenListPop.value
        }
        //永久居留判定
        const checkPermanentResident = () =>{
            if(insureData.value.isPermanentResident){
                insureData.value.residentPeriodDate = ""
            }
        }
        //取得被保人生日
        const getInsureBirthday = (data) => {
            insureData.value.insureBirthday = data;
        }
        //顯示選擇的被保人關係
        const showInsureRelation = () => {
            switch (insureData.value.insureRelation){
                case "SELF":
                    return "本人"
                case "SPOUSE":
                    return "配偶"
                case "CHILD":
                    return "子女"
                case "PARENT":
                    return "父母"
                case "SIBLING":
                    return "兄弟姊妹"
                case "GRANDCHILD":
                    return "祖孫"
                case "OTHER":
                    return "其他"
                default :
                    return "";
            }
        }
        //檢核被保人資料
        const checkForm = () => {
            //姓名檢核
            if (insureData.value.insureName === "") {
                check1.value = true;
            } else {
                check1.value = false;
            }

            if (!CheckData.name(insureData.value.insureName)) {
                check1.value = true;
            } else {
                check1.value = false;
            }
            //英文姓名檢核
            if (props.applicantData.needEnglishPolicy) {
                if (insureData.value.insuredEngName === "") {
                    check2.value = true;
                } else {
                    check2.value = false;
                }

                if(!CheckData.englishName(insureData.value.insuredEngName)){
                    check2.value = true;
                } else {
                    check2.value = false;
                }
            }
            //護照號碼檢核
            if (props.applicantData.needEnglishPolicy) {
                if(insureData.value.passportNo === "") {
                    check13.value = true;
                } else {
                    check13.value = false;
                }
            }
            //身分證檢核
            if (!CheckData.id(insureData.value.insureIdNo)) {
                check3.value = true;
            } else {
                check3.value = false;
            }
            //國籍檢核
            if (insureData.value.insureRiskCountry === "" || insureData.value.insureRiskCountry == null) {
                check4.value = true;
            } else {
                check4.value = false;
            }
            //地址檢核
            if (insureData.value.insureAddrCity === ""
                || insureData.value.insureAddrZip === ""
                || insureData.value.insureAddrs === ""
                || !CheckData.address(insureData.value.insureAddrs)) {
                check6.value = true;
                check7.value = true;
                check8.value = true;
            } else {
                check6.value = false;
                check7.value = false;
                check8.value = false;
            }
            //關係檢核
            if (insureData.value.insureRelation === "") {
                check9.value = true;
            } else {
                check9.value = false;
            }
            //居留證檢核
            if (!idType.value) {
                if (insureData.value.residentIssueDate === "") {
                    check10.value = true;
                } else {
                   check10.value = false;
                }
                if (!insureData.value.isPermanentResident && insureData.value.residentPeriodDate === "") {
                    check11.value = true;
                } else {
                    check11.value = false;
                }
                if (insureData.value.residentBackSn === "") {
                    check12.value = true;
                } else {
                    check12.value= false;
                }
            }

            //觸發 yearChange checkForm();
            yearRef.value?.checkForm(true);

            //觸發受益人檢核
            if(beneficiaryRef.value){
                beneficiaryRef.value.forEach(bfRef => {
                    bfRef?.checkForm();
                });
            }
        }
        //身分證只能大寫
        const upper = _.debounce(() =>{
            if(insureData.value.insureIdNo !== ""){
                insureData.value.insureIdNo = insureData.value.insureIdNo.toString().toUpperCase();
                insureData.value.insureIdNo = CheckData.convertToHalfWidth(insureData.value.insureIdNo);
            }
        },50)

        getRiskCountryList();
        getRiskJobList();
        getAddrCityList();

        defineExpose({ addTraveler,checkForm }) //父組件需使用

        onMounted(()=>{
            loadPageStorage();
            loadDetailStorage();
            window.addEventListener("click", clickOutSide);
        });

        onUnmounted(()=>{
            window.removeEventListener("click", clickOutSide);
        })

        //同要保人-觸發檢查其他被保人
        watch(()=>props.mainSameCheck, (value)=>{
            if(props.user_id !== value){
                insureGlobalSameCheck()
            }
        });

        //監控insureDataRiskCountry
        watch(()=>insureDataRiskCountry.value ,(value)=>{
            insureData.value.insureRiskCountry = value;
            saveInsureData();
        })


</script>

<style lang="scss">
#orderList{
    height:70vh !important;
    overflow-y:scroll;
}
#insureDetail {
    .topCheck {
        margin: 30px 0;

        @media screen and (max-width: $small) {
            font-size: 13px;

            input[type=checkbox]+.checkStyle {
                width: 15px;
                height: 15px;
              margin-right:0;
            }
        }
    }

    .inputTitle.radioLine {
        margin-right: 30px;
    }

    .radioLine {
        display: inline-block;
    }

    .beneficiaryShare {
        background: $blue-400;
        padding: 20px;
        box-sizing: border-box;
        @media screen and (max-width: $small) {
          padding: 10px;
        }
        .btnArea {
            margin: 20px 0;
        }
    }

    .addBeneficiary {
        &.btn {
            background: #fff;
            border: 2px dashed $blue-700;
            color: $blue-700;
          @media screen and (max-width: $small) {
            width:auto;
          }
        }

    }

    .inline .daterangepicker {
        position: absolute;
    }
    .calendar{
        width:100%;
        input{
            background:none;
            border:none;
            font-size:16px;
        }
        .mx-icon-calendar, .mx-icon-clear{
            display: none;
        }
        .mx-input-wrapper{height:100%}
    }

    .reportrange-text {
        background-color: transparent;
        height: 100%;
        padding: 0px;
        border: 0px;
    }

    .daterangepicker .drp-buttons {
        button {
            width: 20%;
            margin: 0px 5px;
        }
    }

    .delete {
        float: right;
        cursor: pointer;
        width: 20px;
    }

    .greenLine {
        margin: 30px 0 15px;
        height: 1px;
    }

    .shareWayArea {
        border-bottom: 1px solid $blue-700;
        margin-bottom: 10px;
      @media screen and (max-width: $small) {
        padding-bottom:10px;
      }
    }

    .popupBg {
        background:rgba(0,0,0,0.5);
        width:100%;
        height:100vh;
        position:fixed;
        top:0;
        left:0;
        z-index: 1000;
        .container{
            background: #FFFFFF;
            border: 1px solid $gray;
            border-radius: 20px;
            width:1200px;
            box-sizing: border-box;
            font-size: 14px;
            text-align: center;
            padding:0 0 30px;
            margin-top:15%;
            .top{
                position:relative;
                h3{
                    font-size:20px;
                    font-weight:500;
                    border-bottom:1px solid #CACCCF;
                    padding:20px 0;
                }
                img{
                    position:absolute;
                    right:20px;
                    top:20px;
                    cursor:pointer;
                }
            }
            @media screen and (max-width: 1200px) {
                width:85%;
                margin-top: 12%;
            }
        }
    }
}
</style>
